import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {change} from 'redux-form';
import {I18n} from 'react-redux-i18n';
import {bindActionCreators} from 'redux';

import LoginForm from './LoginForm';
import {login, showDemoModal, hideDemoModal} from '../actions';
import {isAttemptingLogin, isDemoModalOpen} from '../selectors';

const formName = 'loginForm';


function handleFormSubmit(values, dispatch) {
  return new Promise((resolve, reject) => {
    dispatch(login(values))
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

function handleDemoLogin(language) {
  let user = 'demo' + language + '@petdata.at';
  return function(dispatch) {
    dispatch(login({email:user,password:'Test1234'}));
  };
}

function handleSubmitFail(errors, dispatch) {
  dispatch(change(formName, 'password', ''));
}




function handleFormValidation(values) {
  const invalid_credentials = I18n.t('INVALID_CREDENTIALS');

  const errors = {};

  if (!values.email) {
    errors.email = invalid_credentials;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = invalid_credentials;
  }

  if (!values.password) {
    errors.password = invalid_credentials;
  }

  return errors;
}

const LoginPage = ({
  actions,
  remember, 
  rememberEmail,
  demoModalOpen,  
  
}) => {
  return (
    <LoginForm form={formName}
                onSubmit={handleFormSubmit}
                onSubmitFail={handleSubmitFail}
                validate={handleFormValidation}
                isOpen = {demoModalOpen}
                onDemoClose = {actions.hideDemoModal}
                onStartDemo = {actions.handleDemoLogin}
                onOpenDemoModal = {actions.showDemoModal}
                initialValues={{remember: remember, email: rememberEmail, password: ''}}
    />
  );
};

function mapStateToProps(state) {
  return {
    attemptingLogin: isAttemptingLogin(state),
    demoModalOpen: isDemoModalOpen(state),
    remember: localStorage.rememberUserName ? true : false,
    rememberEmail: localStorage.rememberUserName     
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({showDemoModal, hideDemoModal, handleDemoLogin}, dispatch)
  };
}

LoginPage.propTypes = {
  actions: PropTypes.object.isRequired,
  remember: PropTypes.bool.isRequired,
  rememberEmail: PropTypes.string,
  demoModalOpen: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);


/** WEBPACK FOOTER **
 ** ./src/modules/customer/components/LoginPage.js
 **/